import * as React from "react";
import { sumBy } from "lodash";
import { cn, getCountRequired } from "../libs/helpers/Utils";

interface Props {
	sectionPercent: Array<any>;
	sections: Array<any>;
	checkPanel: Array<string>;
}

export function countProgress({ sectionPercent, sections, checkPanel }: Props) {
	const sum = sumBy(sectionPercent, (o: any) => o.percent);
	let percent = 0;

	if (sum > 0) {
		percent = parseInt(((sum / (getCountRequired(sections, checkPanel) * 100)) * 100).toString(), 10);
	}
	return percent;
}

const uniqueSections = (sectionsPercent, sections) => {
	if (!Array.isArray(sectionsPercent)) {
		return [];
	}
	const sectionIds = sectionsPercent.map((_s) => _s.id);

	return sections.filter((_s) => sectionIds.includes(_s.id));
};

const Progress = ({ sectionPercent, sections, checkPanel }): JSX.Element => {
	const filtredSecion = sectionPercent.filter((_section) => _section?.percent !== null);
	// TODO: remove sumby and add reduce array->fn
	const sum = sumBy(filtredSecion, (o: any) => o.percent);

	if (sum > 0) {
		const _sections = uniqueSections(filtredSecion, sections);
		const percent = parseInt(((sum / (getCountRequired(_sections, checkPanel) * 100)) * 100).toString(), 10);

		return (
			<div className="reportbox-progress">
				<div className="progress">
					<div
						className={cn("progress-bar", {
							"progress-bar-danger": percent > 0 && percent <= 45,
							"progress-bar-warning": percent > 45 && percent < 100,
							"progress-bar-success": percent >= 100,
						})}
						role="progressbar"
						style={{ width: `${percent}%` }}
					>
						{`Заполнено на ${percent || 0}%`}
					</div>
				</div>
			</div>
		);
	}

	return <div />;
};

export default Progress;
